import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
export interface DialogData {
  user_id: string; 
  manageData: any;
}

@Component({
  selector: 'app-staff-comission-pay',
  templateUrl: './staff-comission-pay.component.html',
  styleUrls: ['./staff-comission-pay.component.css']
})
export class StaffComissionPayComponent implements OnInit {
  staffComissionPay: FormGroup;
  public result="";
  public manageDueData:any = {};
  public selectedStaff:string = '';

  constructor(private formBuilder: FormBuilder, public dialogRef: MatDialogRef<StaffComissionPayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService

  ) { }

  ngOnInit() {
    this.staffComissionPay = this.formBuilder.group({     
        comission_amount: [null,Validators.required]   
      });
    if(this.data.manageData)
    {
      if(this.data.manageData.comission_amount && this.data.manageData.comission_amount > 0){
        this.staffComissionPay = this.formBuilder.group({     
          comission_amount: [null,Validators.compose([Validators.required, Validators.maxLength(this.data.manageData.comission_amount)])]   
        });
      }
      this.manageDueData = this.data.manageData;
      this.selectedStaff = this.data.user_id;

      this.staffComissionPay.setValue({
        'comission_amount' : this.data.manageData.comission_amount      
      });
    } 
  }
  isFieldValid(field: string) {
    return (
      !this.staffComissionPay.get(field).valid &&
      this.staffComissionPay.get(field).touched
    );
  }

  updateComissionPay = function(postData, manageDueData, selectedStaff) {      
      this.dueComOptions = {
        id: selectedStaff,
        amount: postData.comission_amount,
        [manageDueData.user_type+'_id']: manageDueData.staff_id
      };
      this.CommonService.apiService(
      "POST",
      "commission/"+manageDueData.user_type+"/payment",
      this.dueComOptions
    ).subscribe(
        (response: any) => {
          if (response.status === true) {           
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 1000
            });            
            this.result=postData.comission_amount;
          }
          window.scrollTo(0, 0);
        },
        err => {
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 1000
          });         
        }
      );
      }

      onNoClick(): void {
        this.dialogRef.close(this.result);
      }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/staff-comission-pay/staff-comission-pay.component.ts